import * as React from 'react';
import * as Styled from './HowItWorks.styles';
import Steps from './Steps';
import CTAButton, { useCTAButtonTracking } from '@ids/pages/landing/CTAButton';
import { useHowItWorksBlock } from '@ids/context';
import Divider from '@ids/components/Layout/Divider';
import Skeleton from '@ids/components/Layout/Skeleton';
import Center from '@ids/components/Layout/Center';

const HowItWorks = () => {
    const howItWorksBlock = useHowItWorksBlock();
    const trackCTAButtonClick = useCTAButtonTracking();

    if (!howItWorksBlock) {
        return <Skeleton height="250vh" />;
    }

    return (
        <React.Fragment>
            <Styled.HowItWorksSection data-testid="how-it-works-block-section" id="how-it-works">
                <Center.Vertical>
                    <Styled.Title>{howItWorksBlock.title}</Styled.Title>
                    <Styled.Description>{howItWorksBlock.description}</Styled.Description>
                </Center.Vertical>
                <Steps steps={howItWorksBlock.stepItems} />
                <Styled.ButtonWrapper>
                    <CTAButton
                        data-testid="how-it-works-cta-button"
                        onClick={() => trackCTAButtonClick('ga_how_it_works_cta')}
                    >
                        {howItWorksBlock.ctaText}
                    </CTAButton>
                </Styled.ButtonWrapper>
            </Styled.HowItWorksSection>
            <Divider />
        </React.Fragment>
    );
};

export default HowItWorks;
